import React, { useEffect, useState } from "react";

import { Navbar } from "../Components/allcomponents";

import "jquery/dist/jquery.min.js";

//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import $ from "jquery";
import { Link } from "react-router-dom";
import axios from "axios";

function Formlist() {
  const [Loading, setLoading] = useState(false);
  const [table, setTable] = useState([]);

  const handleSubmit = async (e) => {
    // setLoading(true);
    await axios
      .post("https://erpapi.eshiksa.net/formBuilderUrlList.php", {
        Branch_id: localStorage.getItem("Branch_id"),
        dbname: "erp_eshiksa",
        tag: "urlListBuilder",
      })
      .then((res) => {
        setLoading(false);
        if (res.data.error !== 1) {
          setTable(res.data.data);
          $(document).ready(function () {
            var table = $("#table_id").DataTable();
            table.destroy();
            $("#table_id").DataTable({
              responsive: true,
            });
          });
        } else {
          return <>NO Data</>;
        }
        // setFormList(res.data.formField);
      })
      .catch((err) => {
        // setLoading(false);
        console.error(err);
      });
  };

  const handleChange = async (e, id) => {
    //setLoading(true);
    await axios
      .post("https://erpapi.eshiksa.net/formBuilderEnableDisable.php", {
        formUrlToken: id,
        dbname: "erp_eshiksa",
        tag: "formEnDi",
        status: e.target.value,
      })
      .then((res) => {
        if (res.data.error !== 1) {
          handleSubmit();
        } else {
          return null;
        }
        // setLoading(false);
        // console.log(res.data);
        // handleSubmit();
      })
      .catch((err) => {
        //setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    handleSubmit();
  }, []);
  return (
    <div>
      <Navbar />
      {Loading ? (
        <div
          style={{
            height: "100vh",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="spinner-border"
            style={{ color: "#88b0bc" }}
            role="status"
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="container border border-1  p-4 rounded-3 mt-5">
          <div className="table-responsive">
            <table
              id="table_id"
              className=" display responsive nowrap"
              width="100%"
            >
              <thead>
                <tr className="table-head">
                  <th scope="col">S. No.</th>
                  <th scope="col">Name of Form</th>
                  <th scope="col">Payment Type</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Total Amount</th>
                  <th scope="col">Total Form Count</th>
                  <th scope="col">Status</th>
                  <th scope="col">View</th>
                  <th scope="col">Edit</th>
                </tr>
              </thead>
              <tbody>
                {table.map((item, i) => {
                  return (
                    <tr key={i + 1}>
                      <td>{i + 1}</td>
                      <td>{item.formName}</td>
                      <td>{item.paymentType}</td>
                      <td>{item.fixedAmount}</td>
                      <td>{item.total_amount}</td>
                      <td>{item.transaction_cout}</td>
                      <td>
                        <select
                          onChange={(e) => handleChange(e, item.formUrlToken)}
                          className="form-control"
                          value={item.status}
                        >
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </select>
                      </td>

                      <td>
                        <Link to={`/Form/${item.formUrlToken}`}>
                          <button
                            type="button"
                            className="btn btn-sm "
                            id={`see${i + 1}`}
                          >
                            <i className="fa-regular text-primary fa-eye "></i>
                          </button>
                        </Link>
                      </td>
                      <td>
                        <Link to={`/EditForm/${item.formUrlToken}`}>
                          <button
                            type="button"
                            className="btn btn-sm "
                            id={`edit${i + 1}`}
                          >
                            <i className="fa-regular text-primary fa-edit "></i>
                          </button>
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default Formlist;
